'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _action_type = require('../constants/action_type');

var initialState = {
  outline: {},
  output: { result: [] }
};

var updatePredict = function updatePredict(state, action) {
  var payload = action.payload;

  return Object.assign({}, state, payload);
};

var predictReducer = function predictReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _action_type.PREDICT.PREDICT_INIT:
    case _action_type.PREDICT.PREDICT_TO_WRITE_INIT:
      return Object.assign({}, state, initialState);
    case _action_type.PREDICT.PREDICT_DONE:
      return Object.assign({}, state, updatePredict(state, action));
    case _action_type.PREDICT.ADD_PRED_JSON_INIT:
      return Object.assign({}, state, action.payload);
    case _action_type.FILE.ADD_FAIL:
    case _action_type.FILE.CONVERT_FAIL:
    case _action_type.MOL.ADD_FAIL:
    case _action_type.MOL.CONVERT_DONE:
    case _action_type.MOL.CONVERT_FAIL:
    case _action_type.PREDICT.PREDICT_FAIL:
    case _action_type.FORM.SUBMIT:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

exports.default = predictReducer;